import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=60f4739d&scoped=true"
import script from "./NewRegister.vue?vue&type=script&lang=js"
export * from "./NewRegister.vue?vue&type=script&lang=js"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=60f4739d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4739d",
  null
  
)

export default component.exports